import { render } from "./ChatMain.vue?vue&type=template&id=13ea9d4c&scoped=true"
import script from "./ChatMain.vue?vue&type=script&lang=js"
export * from "./ChatMain.vue?vue&type=script&lang=js"

import "./ChatMain.vue?vue&type=style&index=0&id=13ea9d4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ea9d4c"]])

export default __exports__